/**
 * Where this page works now: a space (on which server), with the way back; or the board of
 * this computer (the desktop app, offline) or of the server.
 */
import { Show, type JSX } from "solid-js";
import { useApp } from "../../app/context";

/** Says where you work, and offers the way back from a space. */
export function Here(): JSX.Element {
  const { spaces, project } = useApp();
  /** The board's name (a space's project is named after it). */
  const name = () => project.state()?.name ?? "…";
  return (
    <section class="grp" id="home-here" data-where={spaces.current ? (spaces.remote ? "remote" : "space") : "board"}>
      <h3>Now</h3>
      <Show
        when={spaces.current}
        fallback={
          <p class="small muted">
            Working on <b>{name()}</b>, {spaces.onThisComputer ? "on this computer" : "the server's open board"}. Sign in to a server below to work with your team.
          </p>
        }
      >
        {(space) => (
          <>
            <p>
              In the space <b>{name()}</b> on <span class="mono">{new URL(space().server).host}</span>.
            </p>
            <button type="button" class="btn" id="home-leave" onClick={() => spaces.leave()}>
              {spaces.remote ? "Back to this computer" : "Back to your spaces"}
            </button>
          </>
        )}
      </Show>
    </section>
  );
}
